/**
 * BanUserModal — confirm banning a user with optional reason.
 * Extracted from ManagePlatform.js
 */
import { XCircle, Loader2 } from 'lucide-react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';

export default function BanUserModal({
  open,
  onOpenChange,
  selectedUser,
  banReason,
  setBanReason,
  onCancel,
  onConfirm,
  processingUser,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#1a1a2e] border border-[#2a2a4e] text-white"
        data-testid="ban-user-modal"
      >
        <DialogHeader>
          <DialogTitle className="text-red-400 flex items-center gap-2">
            <XCircle className="h-5 w-5" />
            حظر المستخدم
          </DialogTitle>
          <DialogDescription className="text-[#808080]">
            سيتم حظر حساب {selectedUser?.name || selectedUser?.email} ولن يتمكن من الدخول للمنصة
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <label className="block text-sm font-medium text-[#c9a227] mb-2">
              سبب الحظر (اختياري)
            </label>
            <textarea
              value={banReason}
              onChange={(e) => setBanReason(e.target.value)}
              placeholder="اكتب سبب الحظر..."
              className="w-full bg-[#0a0a0a] border border-[#2a2a4e] text-white rounded-xl p-3 min-h-[100px] focus:border-[#c9a227] focus:outline-none"
              data-testid="ban-user-reason"
            />
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={onCancel}
            className="border-[#2a2a4e] text-white hover:bg-[#2a2a4e]"
            data-testid="ban-user-cancel-btn"
          >
            إلغاء
          </Button>
          <Button
            onClick={onConfirm}
            disabled={processingUser === selectedUser?.id}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid="ban-user-confirm-btn"
          >
            {processingUser === selectedUser?.id ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <>
                <XCircle className="h-4 w-4 me-2" />
                حظر الحساب
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
